import { Box } from '@mui/material';
import React from 'react';
import { AuthData } from '../../../context/auth';
import { ErrorData } from '../../../context/ErrorProvider';
import {
	RenewalData,
	withRenewalContext,
} from '../../../context/RenewalProvider';
import { HEADER_HEIGHT } from '../../../data/constants';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../../common';
import FutureInvoicesTable from '../../FutureInvoicesTable';
import NewInvoicesTable from '../../NewInvoicesTable';

interface Props {
	authData: AuthData;
	renewalData: RenewalData;
	errorData: ErrorData;
}

const InvoicesView = (props: Props) => {
	const { renewalData } = props;

	const { renewalUpdateObj, policy } = renewalData;

	const invoices = renewalUpdateObj.invoice ? [renewalUpdateObj.invoice] : [];

	if (!renewalUpdateObj.invoice && renewalUpdateObj.plannedInvoices) {
		return (
			<>
				<StyledTitleContainer>
					<StyledTitle>Planned Invoices</StyledTitle>
				</StyledTitleContainer>
				<hr />
				<StyledSectionContainer>
					<FutureInvoicesTable
						invoices={renewalUpdateObj.plannedInvoices}
						currency={policy?.currency}
					/>
				</StyledSectionContainer>
			</>
		);
	}

	return (
		<Box
			sx={{
				pt: 4,
				pb: 4,
				backgroundColor: 'background.default',
				height: `calc(100vh - ${HEADER_HEIGHT}px)`,
			}}
		>
			<NewInvoicesTable
				invoices={invoices}
				policyholderLocator={policy.policyholderLocator}
				currency={policy.currency}
			/>
		</Box>
	);
};

export default withRenewalContext<Props>(InvoicesView);
